import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
	FormBuilder,
	FormControl,
	FormGroup,
	NgForm,
	Validators,
} from "@angular/forms";
import { takeUntil, first } from "rxjs/operators";
import { BehaviorSubject, Subject } from "rxjs";

import { User, Role } from "app/auth/models";
import { AuthenticationService } from "app/auth/service";
import { CoreConfigService } from "@core/services/config.service";
import { ToastrService } from "ngx-toastr";
import { UsuarioService } from "@core/services/usuario.service";
import Swal from "sweetalert2";

@Component({
	selector: "app-auth-redefinir-senha",
	templateUrl: "./redefinir-senha.component.html",
	styleUrls: ["./redefinir-senha.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class RedefinirSenhaComponent implements OnInit {
	//  Public
	public coreConfig: any;
	public loginForm: FormGroup;
	public changePasswordForm: FormGroup;
	public loading = false;
	public href;
	public enviar = false;
	public alterar = false;
	public expirado = false;
	public submitted = false;
	public buttonLogin = true;
	public returnUrl: string;
	public error = "";
	public sucess = "";
	public passwordTextType: boolean;
	public token;
	private currentUserSubject: BehaviorSubject<User>;

	// Private
	private _unsubscribeAll: Subject<any>;

	constructor(
		private _coreConfigService: CoreConfigService,
		private _formBuilder: FormBuilder,
		private _route: ActivatedRoute,
		private _router: Router,
		private _authenticationService: AuthenticationService
	) {
		this.changePasswordForm = new FormGroup({
			confirm_password: new FormControl(),
			new_password: new FormControl(),
		});

		this.loginForm = new FormGroup({
			email: new FormControl(),
		});

		if (this._authenticationService.currentUserValue) {
			this._router.navigate(["/cliente"]);
		}

		this.currentUserSubject = new BehaviorSubject<User>(
			JSON.parse(localStorage.getItem("currentUser"))
		);
		this._unsubscribeAll = new Subject();

		// Configure the layout
		this._coreConfigService.config = {
			layout: {
				navbar: {
					hidden: true,
				},
				menu: {
					hidden: true,
				},
				footer: {
					hidden: true,
				},
				customizer: false,
				enableLocalStorage: false,
			},
		};
	}

	get f() {
		return this.loginForm.controls;
	}

	togglePasswordTextType() {
		this.passwordTextType = !this.passwordTextType;
	}

	alterarSenha() {
		this.loading = true;

		if (this.changePasswordForm.value.new_password == null) {
			this.loading = false;
			this.error = "Campos obrigatórios.";
			return;
		} else {
			if (this.changePasswordForm.value.new_password.length < 6) {
				this.loading = false;
				this.error =
					"A senha deve ter pelo menos 6 caracteres, incluindo números e letras.";
				return;
			} else {
				if (
					this.changePasswordForm.value.new_password ==
					this.changePasswordForm.value.confirm_password
				) {
					this._authenticationService
						.insertPassword(
							this.token,
							this.changePasswordForm.value.new_password
						)
						.subscribe(
							(res) => {
								if (res == false) {
									this.error = "Erro de autenticação. Solicite um novo link.";
									this.loading = false;
								} else {
									this.error = "Senha alterada com sucesso!";
									this.loading = false;
									this.alterar = true;
									this.buttonLogin = false;
								}
							},
							(error) => {
								this.error = "Erro interno. Tente novamente.";
								this.loading = false;
							}
						);
				} else {
					this.loading = false;
					this.error = "As senhas são diferentes.";
				}
			}
		}
	}

	onSubmit() {
		this.submitted = true;

		if (this.loginForm.value.email == null) {
			this.loading = false;
			this.error = "Campos obrigatórios.";
			return;
		} else {
			this.loading = true;
			this._authenticationService.passwordRecovery(this.loginForm.value.email).subscribe(
				(res) => {
					if (res) {
						this.loading = false;
						this.error =
							"As instruções foram enviadas para o email caso esteja cadastrado.";
					} else {
						this.loading = false;
						this.error = "Erro interno. Tente novamente.";
					}
				},
				(error) => {
					this.error = "Erro interno. Tente novamente.";
					this.loading = false;
				}
			);
		}

	}

	ngOnInit(): void {
		var param = { token: "" };
		var s = window.location.search.substring(1).split("&");
		for (var i = 0; i < s.length; ++i) {
			var parts = s[i].split("=");
			param[parts[0]] = parts[1];
		}
		this.token = param.token;
		if (param.token == "") {
			this.alterar = true;
		} else {
			this._authenticationService
				.tokenValidation(param.token)
				.subscribe((res) => {
					if (res.length != 0) {
						const then = new Date(res[0].dt_token);

						const now = new Date();

						const msBetweenDates = Math.abs(then.getTime() - now.getTime());

						const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);

						if (hoursBetweenDates < 8) {
							this.enviar = true;
						} else {
							this.expirado = true;
							Swal.fire({
								title: "Link Expirado!",
								text: "Reenvie o email para redefinir a senha.",
								icon: "error",
								confirmButtonText: "Reenviar",
							}).then((result) => {
								if (result.isConfirmed) {
									location.href = "/redefinir-senha";
								}
							});
						}
					} else {
						Swal.fire({
							title: "Link Expirado!",
							text: "Reenvie o email para redefinir a senha.",
							icon: "error",
							confirmButtonText: "Reenviar",
						}).then((result) => {
							if (result.isConfirmed) {
								location.href = "/redefinir-senha";
							}
						});
					}
				});
		}

		// get return url from route parameters or default to '/'
		this.returnUrl = this._route.snapshot.queryParams["returnUrl"] || "/";

		// Subscribe to config changes
		this._coreConfigService.config
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((config) => {
				this.coreConfig = config;
			});
	}

	/**
	 * On destroy
	 */
	// ngOnDestroy(): void {
	//   // Unsubscribe from all subscriptions
	//   this._unsubscribeAll.next();
	//   this._unsubscribeAll.complete();
	// }
}
